/* ============================================================================
   McDuffy Quiz v2 — POUCH renderer (SVG <text> overlays on a baked pouch photo)
   ----------------------------------------------------------------------------
   Ported from assets/mcduffy-quiz.js (the LIVE quiz's canonical renderer).
   Architecture + exact coordinates: POUCH-RENDERER-SPEC.md (required reading).
   Do NOT revert to CSS-divs. Cover rects MUST precede text in document order.

   Exposes:  window.MQ_POUCH = { markup(imgUrl, idSuffix, variant),
                                  paint(rootEl, opts), pickPlan(dailyGrams) }
   Load order: after data.js, before view.js (view + boot both consume it).
   ============================================================================ */
(function () {
  'use strict';

  var recipeNames = {
    surf_turf: 'Surf n Turf',
    farmyard_feast: 'Farmyard Feast',
    coastal_blend: 'Coastal Blend',
    chicken_rice: 'Chicken It Up',
    beef_rice: 'Braised Beef Bowl',
    pork_rice: 'Hearty Pork Rice'
  };
  var POUCH_INGREDIENTS = {
    chicken_rice:   'CHICKEN • SWEET POTATO • SPINACH',
    surf_turf:      'BEEF • SARDINE • SWEET POTATO',
    farmyard_feast: 'PORK • CHICKEN • SQUASH',
    coastal_blend:  'TILAPIA • CATFISH • CARROTS',
    beef_rice:      'BEEF TRIPE • SWEET POTATO • SQUASH',
    pork_rice:      'PORK • SWEET POTATO • SQUASH'
  };

  function formatDogName(raw) { if (!raw) return null; var n = String(raw).trim(); return n ? n.charAt(0).toUpperCase() + n.slice(1) : null; }
  function displayDogName(raw) { return formatDogName(raw) || 'Your dog'; }
  function possessiveDogName(raw) {
    var n = formatDogName(raw);
    if (!n) return "Your dog's";
    return n.charAt(n.length - 1).toLowerCase() === 's' ? n + "'" : n + "'s";
  }
  function packsLabel(p, dailyG) {
    var v = parseFloat(p);
    /* Only 500g pouches ship. A fractional "0.5 Packs Per Day" on an unmarked
       pouch reads as half-a-pouch and 2x-overfeeds small dogs — print the exact
       grams instead whenever the day is less than one whole pouch. */
    var g = parseFloat(dailyG);
    if (!isNaN(g) && g > 0 && (isNaN(v) || v < 1)) return '≈' + Math.round(g) + 'g Per Day';
    if (isNaN(v) || v <= 0) return '1 Pack Per Day';
    var r = Math.round(v * 2) / 2; if (r < 0.5) r = 0.5;
    var pretty = (r % 1 === 0) ? String(r) : r.toFixed(1);
    return pretty + (r === 1 ? ' Pack Per Day' : ' Packs Per Day');
  }
  function pouchTodayStr() {
    var d = new Date(), m = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    return m[d.getMonth()] + ' ' + d.getDate() + ' ' + d.getFullYear();
  }
  function pouchDefaultBatch() {
    var d = new Date(), doy = Math.floor((d - new Date(d.getFullYear(), 0, 0)) / 86400000);
    return 'M-' + d.getFullYear() + '-' + String(doy).padStart(3, '0');
  }
  function setOverlayIn(root, key, val) {
    if (!root) return;
    var n = root.querySelectorAll('[data-overlay="' + key + '"]');
    for (var i = 0; i < n.length; i++) n[i].textContent = val;
  }
  /* Long-name auto-shrink: Inter 800 at 80px fits ~10 chars in the 588u label width. */
  function fitDogNameFont(root, poss) {
    var nodes = root.querySelectorAll('[data-overlay="name-poss"]');
    for (var i = 0; i < nodes.length; i++) {
      var len = (poss || '').length, size = 80;
      if (len > 10) size = Math.max(46, Math.floor(80 * 10 / len));
      nodes[i].setAttribute('font-size', String(size));
    }
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* Pack-per-day decision. pouchSize is ALWAYS 500: no 250g SKU exists anywhere
     in pricing/variants/fulfillment (verified 2026-07-14) — the old 250 branches
     produced labels like "0.5 Packs Per Day" against a phantom pouch size. If a
     250g pouch ever ships, restore size selection here AND print the size on the
     label in every renderer (see POUCH-RENDERER-SPEC.md). */
  function pickPlan(dailyGrams) {
    if (!dailyGrams || dailyGrams <= 0) return { pouchSize: 500, packsPerDay: 0.5, packsPerWeek: 4 };
    function snap(n) { return Math.max(0.5, Math.round(n * 2) / 2); }
    var p500 = snap(dailyGrams / 500);
    return { pouchSize: 500, packsPerDay: p500, packsPerWeek: Math.round(p500 * 7) };
  }

  /* Emit the .mc-pouch markup (mirrors snippets/mcduffy-pouch-mockup.liquid).
     Cover rects BEFORE text; ingredients rect+text share the rotate(-1.2) group. */
  function markup(imgUrl, idSuffix, variant) {
    idSuffix = idSuffix || ''; variant = variant || 'full';
    return '' +
      '<div class="mc-pouch mc-pouch--' + variant + '" id="mc-pouch' + esc(idSuffix) + '" data-pouch-mockup data-recipe="chicken_rice">' +
        '<img class="mc-pouch__photo" src="' + esc(imgUrl) + '" alt="McDuffy pouch" width="1000" height="1204" loading="eager" data-pouch-photo>' +
        '<svg class="mc-pouch__svg" viewBox="0 0 1886 2272" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
          '<rect x="671" y="1027" width="588" height="36" fill="#f3f2f2"/>' +
          '<g transform="rotate(-1.2 954 1190)"><rect x="671" y="1173" width="588" height="34" fill="#f3f2f2"/></g>' +
          '<rect x="671" y="1276" width="588" height="24" fill="#f3f2f2"/>' +
          '<rect x="671" y="1314" width="588" height="34" fill="#f3f2f2"/>' +
          '<text class="mc-ovr mc-ovr--name" x="954" y="978" font-size="80" data-overlay="name-poss"></text>' +
          '<text class="mc-ovr mc-ovr--recipe" x="954" y="1047" font-size="30" data-overlay="recipe-line"></text>' +
          '<g transform="rotate(-1.2 954 1190)"><text class="mc-ovr mc-ovr--ingr" x="954" y="1190" font-size="22" data-overlay="ingredients"></text></g>' +
          '<text class="mc-ovr mc-ovr--feed" x="954" y="1289" font-size="20" data-overlay="feed-name"></text>' +
          '<text class="mc-ovr mc-ovr--packs" x="954" y="1333" font-size="30" data-overlay="packs"></text>' +
          '<text class="mc-ovr mc-ovr--date" x="954" y="1491" font-size="24" data-overlay="date"></text>' +
          '<text class="mc-ovr mc-ovr--batch" x="954" y="1590" font-size="24" data-overlay="batch"></text>' +
        '</svg>' +
      '</div>';
  }

  /* Swap the overlay text for a specific dog/recipe. Clone-and-repaint each
     pouch directly — never the live quiz's lockstep updatePouchMockup. */
  function paint(root, opts) {
    if (!root) return;
    opts = opts || {};
    var recipe = opts.recipe || 'chicken_rice';
    var dogName = displayDogName(opts.dogName);
    var pouchSize = opts.pouchSize || 500;
    var packsPerDay = opts.packsPerDay;
    if ((packsPerDay == null) && opts.dailyG && pouchSize) packsPerDay = Math.max(0.5, Math.round((opts.dailyG / pouchSize) * 2) / 2);
    if (packsPerDay == null) packsPerDay = 1;
    var recipeTitle = recipeNames[recipe] || 'Chicken It Up';
    var ingredients = POUCH_INGREDIENTS[recipe] || POUCH_INGREDIENTS.chicken_rice;
    var possessive = possessiveDogName(opts.dogName);
    root.setAttribute('data-recipe', recipe);
    var photo = root.querySelector('[data-pouch-photo]');
    if (photo) photo.alt = 'McDuffy pouch personalized for ' + dogName;
    setOverlayIn(root, 'name-poss', possessive);
    setOverlayIn(root, 'recipe-line', recipeTitle + ' Recipe');
    setOverlayIn(root, 'ingredients', ingredients);
    setOverlayIn(root, 'feed-name', 'FEED ' + dogName.toUpperCase());
    setOverlayIn(root, 'packs', packsLabel(packsPerDay, opts.dailyG));
    setOverlayIn(root, 'date', opts.date || pouchTodayStr());
    setOverlayIn(root, 'batch', opts.batch || pouchDefaultBatch());
    fitDogNameFont(root, possessive);
  }

  window.MQ_POUCH = { markup: markup, paint: paint, pickPlan: pickPlan, recipeNames: recipeNames };
})();
